import svg4everybody from 'svg4everybody';
import * as components from './components';
import { initialiseCurrentCulture } from './util/momentLocale';

if (module.hot) module.hot.accept();

initialiseCurrentCulture();
svg4everybody();

[...document.querySelectorAll('[data-component]')].forEach((element) => {
  const componentName = element.getAttribute('data-component');

  const isValidName = Object.prototype.hasOwnProperty.call(components, componentName);
  if (!isValidName) throw Error(`Invalid component: ${componentName}`);

  const isValidConstructor = typeof components[componentName] === 'function';
  if (!isValidConstructor) throw Error(`Invalid constructor: ${componentName}`);

  return new components[componentName](element);
});
